var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#1a181c"
    }
  }, [_c('div', {
    staticClass: "container pt-40 color-fff"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-20 bold mb-20"
  }, [_vm._v("主办机构")]), _vm._v(" "), _vm._l((_vm.list1), function(v, i) {
    return _c('a', {
      key: i,
      staticClass: "pl-20 fs-16 mb-20 link",
      attrs: {
        "href": v.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-20 bold mb-20"
  }, [_vm._v("执行机构")]), _vm._v(" "), _c('a', {
    staticClass: "pl-20 fs-16 mb-20 link",
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("广州展联展览服务有限公司\n          ")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-20 bold mb-20"
  }, [_vm._v("承办机构")]), _vm._v(" "), _vm._l((_vm.list2), function(v, i) {
    return _c('a', {
      key: i,
      staticClass: "pl-20 fs-16 mb-20 link",
      attrs: {
        "href": v.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "block mb-40"
  }, [_c('div', {
    staticClass: "b-title pl-20 fs-20 bold mb-20"
  }), _vm._v(" "), _vm._l((_vm.list3), function(v, i) {
    return _c('a', {
      key: i,
      staticClass: "pl-20 fs-16 mb-20 link",
      attrs: {
        "href": v.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, _vm._l((_vm.imgList), function(item) {
    return _c('b-row', {
      key: item
    }, [_c('b-col', [_c('img', {
      staticClass: "logo_img mb-20",
      attrs: {
        "src": item
      }
    })])], 1)
  }), 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "fs-20 pt-30 pb-30"
  }, [_c('div', {
    staticClass: "nav mb-bottom"
  }, _vm._l((_vm.nav), function(v, i) {
    return _c('a', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.toFriend(v.url)
        }
      }
    }, [_vm._v(_vm._s(v.name) + "\n          "), (i < 3) ? _c('span', {
      staticClass: "ml-20 mr-20"
    }, [_vm._v("|")]) : _vm._e()])
  }), 0), _vm._v(" "), _vm._m(0)])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright  clearfix"
  }, [_c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("\n          广州展联展览服务有限公司版权所有\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 粤ICP备17092841号-4")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d85102e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageBottom.vue
// module id = null
// module chunks = 